/**
 * Created by cd01 on 2017/7/13.
 */

{
    angular.module('interfaceModule')
        .controller('RechargeController',RechargeController);
    RechargeController.$inject = ['$scope',"$state",'$http','$stateParams','utils.constant','alertControl','utils.platform',
        '$timeout','utils.common','requestHandler','ModalWindow','utils.currentUser','request.order'];
    function RechargeController($scope,$state,$http,$stateParams,constant,alertControl,platform,$timeout,common,requestHandler,ModalWindow,currentUser,orderRequest){
        let vm = this;
        $scope.vm = vm;
        let collect = {
            'appPayUrl_ali':constant.config.sitePath+constant.action.appPay_ali,
            'appPayUrl_wechat':constant.config.sitePath+constant.action.appPay_wechat,
            'appPayUrl_wopay_recharge':constant.config.sitePath+constant.action.appPay_wo_recharge,
            // 'appPayUrl_wechat':constant.config.sitePath+constant.action.appPay_wechat_test,
            'activate':activate,
            'gotoPay':gotoPay,
            'mobileClick':mobileClick,
            'woPayRecharge':woPayRecharge,
            'bocPayRecharge':bocPayRecharge,

            'isshowbtn7':false,

            'chooseMoneyOthers':chooseMoneyOthers,
            'chooseMoneyBOC':chooseMoneyBOC,
            'bocDiscount_0':1,
            'bocpayamount_0':"",
            'bocDiscount_1':1,
            'bocpayamount_1':"",

            'bocpayamount':"",
            'bocpayamount':"",

            'bocpayamount_order':"",        // 下单时，使用原支付金额

            'checkPayResult':checkPayResult,
            'checkInterval':1000,
            'timer':null,
            'isMobile':false,
            'isWechat':false,
            'qrpayModal':null,   //弹窗
            'accountbalance':'',
            'payMethod':0,
            'rechargeMomey':null,
            'orderInfo': {},
            'money':'',
            'manager':null,

            'choseMoney': choseMoney,
            'rechargegift': "0",  //赠送比例
            'rechargeinfo':null,//可充值金额及赠送金额信息
            'getRechargeInfo':getRechargeInfo,
            'discountinfo':null,
            'getPayDiscount':getPayDiscount,//获取余额支付折扣
            'getUserInfo':getUserInfo,
            'debuglog':debuglog
        };

        let moneyItem = {
            "item1" : '1',
            "item2" : '5',
            "item3" : '10',
            "item4" : '20',
            "item5" : "50",
            "item6" : "100"
        }
        vm.collect=collect;
        vm.moneyItem = moneyItem;
        activate();
        function activate(){
            //获取充值赠送比例
            //getRechargeGift();

            console.log('RechargeController',$scope.userId);

            collect.isMobile=platform.isIOS()||platform.isAndroid();
            collect.isWechat=platform.isWechat();

            collect.payMethod=collect.isMobile&&collect.isWechat?1:0;

            collect.orderInfo.amount = 0;
            collect.orderInfo.payAction = 0;    //交易类型：接口是参数transtype ，0 余额充值   1 支付

            //console.log('浏览器缓存：',JSON.parse(sessionStorage.getItem("rechargeInfo")))
            requestHandler.simpleRequest(constant.action.getUserId).then(function (respone) {
                if(respone.data[0].result==1){
                    collect.userId=respone.data[0].loginuserid;
                    console.log("当前登录用户id",collect.userId);
                    collect.userName=collect.userId;
                    collect.orderInfo.userId = collect.userId;

                    getRechargeInfo();
                    getOrderBOCPayInfo(20, 0);

                }else{
                    $state.go('login');
                }

            }).then(function () {
                collect.getUserInfo();
            });
            getPayDiscount();
            $scope.$on("$destroy", function(e) {
                console.log(collect.timer);
                $timeout.cancel(collect.timer);

            });

            $scope.$on("$destroy", function(e) {
                console.log('$on');
                if(collect.qrpayModal){
                    //$scope.$close();
                    console.log('collect.qrpayModal');
                    collect.qrpayModal.close();

                }

            });
            let userid = sessionStorage.getItem("userId");

            $("#bocpay_button_7").hide();
        }

        function woPayRecharge(){
            console.log('进行沃支付充值');

            var  orderId =orderRequest.setRechargeOrderId(collect.userId);
            collect.orderInfo.orderId = orderId;
            collect.orderInfo.paytype = collect.payMethod;    //充值平台
            //用浏览器存储充值单信息：
            var info = JSON.stringify(collect.orderInfo);
            sessionStorage.setItem("rechargeInfo",info);
            var rechargeInfo =JSON.parse(sessionStorage.getItem("rechargeInfo"));
            let data = [{
                'userid':rechargeInfo.userId,
                'orderid':rechargeInfo.orderId,
                'paytype':rechargeInfo.paytype,
                'amount':rechargeInfo.amount
            }];
            let paramsStr = "rechargeinfo=" + JSON.stringify(data);
            console.log("recharge string:");
            console.log(paramsStr);
            console.log("recharge string end-----------------------------");

            requestHandler.simpleRequest(constant.action.appPay_wo_recharge, paramsStr,
                function successCallback(response) {
                    console.log(response);

                    var form = $("<form></form>")
                    form.attr('action',response.data[0].gate_way)
                    form.attr('method','post')
                    var input1 = $("<input type='hidden' name='param' />")
                    input1.attr('value',response.data[0].params)
                    form.append(input1)
                    form.appendTo("body")
                    form.css('display','none')
                    form.submit()
                },
                function errorCallback(response) {
                    console.log('支付出现失败');
                    let alert=common.alert('',
                        '连接不到数据库，请查看网络',
                        [{
                            'title':'确认',
                            'action':function(){
                                alert.close();
                            }
                        }]);
                    // 请求失败执行代码
                }
            );

        };

        function bocPayRecharge(){
            console.log('进行中行支付充值');

            console.log('进行中行支付');

            /*
            orderinfo: {
                userid,			// 用户账号ID
                    orderid,			// 订单号
                    ordertype,		// 订单类型，0：普通订单，1：充值订单
                    amount,			// 充值订单金额，取值：6，10。
                    subject,			// 订单标题（上传文件名称）
                    discounttype,       // 6：不使用优惠，7：使用随机优惠，8：使用1折优惠
            }
            */

            var  orderId =orderRequest.setRechargeOrderId(collect.userId);
            collect.orderInfo.orderId = orderId;
            collect.orderInfo.paytype = collect.payMethod;    //充值平台
            //用浏览器存储充值单信息：
            var info = JSON.stringify(collect.orderInfo);
            sessionStorage.setItem("rechargeInfo",info);
            var rechargeInfo =JSON.parse(sessionStorage.getItem("rechargeInfo"));

            //浏览器存储支付方式：
            let data={
                'userid':rechargeInfo.userId,
                'orderid':rechargeInfo.orderId,
                'ordertype':1,
                'amount':collect.bocpayamount_order,
                'subject':'rechargeBalance',
                'discounttype':collect.payMethod
            };
            let paramsStr='orderinfo='+JSON.stringify(data);

            requestHandler.simpleRequest(constant.action.appPay_boc_new, paramsStr,
                function successCallback(response) {
                    console.log(response);

                    /*
                    1 $('#payType').attr("value", obj['payType']);
                    2 $('#orderNo').attr("value", obj['orderNo']);
                    3 $('#curCode').attr("value", obj['curCode']);
                    4 $('#orderAmount').attr("value", obj['orderAmount']);
                    5 $('#orderTime').attr("value", obj['orderTime']);
                    6 $('#orderNote').attr("value", obj['orderNote']);
                    7 $('#terminalChnl').attr("value", obj['terminalChnl']);
                    8 $('#payPattern').attr("value", obj['payPattern']);
                    9 $('#merchantNo').attr("value", obj['merchantNo']);
                    10 $('#orderUrl').attr("value", obj['orderUrl']);
                    11 $('#signData').attr("value", obj['signData']);
                    */

                    var form = $("<form></form>");
                    form.attr('action','https://ebspay.boc.cn/PGWPortal/B2CMobileRecvOrder.do');
                    form.attr('method','post');

                    var input1 = $("<input type='hidden' name='payType' />");
                    input1.attr('value',response.data.payType);
                    form.append(input1);

                    var input2 = $("<input type='hidden' name='orderNo' />");
                    input2.attr('value',response.data.orderNo);
                    form.append(input2);

                    var input3 = $("<input type='hidden' name='curCode' />");
                    input3.attr('value',response.data.curCode);
                    form.append(input3);

                    var input4 = $("<input type='hidden' name='orderAmount' />");
                    input4.attr('value',response.data.orderAmount);
                    form.append(input4);

                    var input5 = $("<input type='hidden' name='orderTime' />");
                    input5.attr('value',response.data.orderTime);
                    form.append(input5);

                    var input6 = $("<input type='hidden' name='orderNote' />");
                    input6.attr('value',response.data.orderNote);
                    form.append(input6);

                    var input7 = $("<input type='hidden' name='terminalChnl' />");
                    input7.attr('value',response.data.terminalChnl);
                    form.append(input7);

                    var input8 = $("<input type='hidden' name='payPattern' />");
                    input8.attr('value',response.data.payPattern);
                    form.append(input8);

                    var input9 = $("<input type='hidden' name='merchantNo' />");
                    input9.attr('value',response.data.merchantNo);
                    form.append(input9);

                    var input10 = $("<input type='hidden' name='orderUrl' />");
                    input10.attr('value',response.data.orderUrl);
                    form.append(input10);

                    var input11 = $("<input type='hidden' name='signData' />");
                    input11.attr('value',response.data.signData);
                    form.append(input11);

                    form.appendTo("body");
                    form.css('display','none');
                    form.submit();
                },
                function errorCallback(response) {
                    console.log('支付出现失败');
                }
            );

            //alert("马上推出，敬请期待");
        };

        function getRechargeInfo() {//获取可充值金额及赠送金额
            let _data = [{
                'operationtype': '1',
                'userid': collect.userId
            }];

            let params = "rechargeinfo=" + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.rechargeconfig, params,
                function (response) {
                    console.log("返回充值和赠送的信息：",response);
                    if(response.data[0].result == 1){
                        collect.rechargeinfo = response.data[0].rechargeinfo;
                        collect.orderInfo.amount = collect.rechargeinfo[0].money;

                        if (collect.rechargeinfo[0].isbocpay == '1')
                        {
                            if (collect.rechargeinfo[0].bocpay_index == "1")
                            {
                                $("#bocpay_button_6").show();
                                $("#bocpay_button_7").hide();
                                $("#bocpay_button_8").show();
                            }
                            else if (collect.rechargeinfo[0].bocpay_index == "2")
                            {
                                $("#bocpay_button_6").show();
                                $("#bocpay_button_7").show();
                                $("#bocpay_button_8").hide();
                            }
                            /*
                            $("#bocpay_button_6").show();
                            $("#bocpay_button_7").show();
                            $("#bocpay_button_8").show();
                            */
                            $("#alipay_button").hide();
                            $("#wxpay_button").hide();
                            $("#wopay_button").hide();
                            collect.payMethod=6;
                        }

                        if(collect.isMobile){
                            console.log('手机端');
                            checkPayResult();
                        }
                    }else if(response.data[0].result == 0){
                        common.alert("获取充值信息失败");
                    }
                })

        }
        function mobileClick(){

            //进来就预备生成充值订单信息
            var  orderId =orderRequest.setRechargeOrderId(collect.userId);
            collect.orderInfo.orderId = orderId;
            collect.orderInfo.paytype = collect.payMethod;    //充值平台
            //用浏览器存储充值单信息：
            var info = JSON.stringify(collect.orderInfo);
            sessionStorage.setItem("rechargeInfo",info);
            var rechargeInfo =JSON.parse(sessionStorage.getItem("rechargeInfo"));
            let data = [{
                'userid':rechargeInfo.userId,
                'orderid':rechargeInfo.orderId,
                'paytype':rechargeInfo.paytype,
                'amount':rechargeInfo.amount
            }];
            let params = "rechargeinfo=" + JSON.stringify(data);

            //测试用接口标记，所以注释这里。
           // requestHandler.simpleRequest(constant.action.balancetransaction_insert, params,function (response) {
           //      console.log("预备充值信息",response);
           //  });
           //  console.log('充值信息',collect.orderInfo);

            //测试用接口标记，所以注释这里。
        }

        function gotoPay(){

            if(isNaN(parseFloat(collect.orderInfo.amount))){
               let alert=alertControl.show('',
                        '金额请输入数字',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                );
                return;
            }
            console.log('进行调取支付');
            common.loading.show();
            //生成充值订单：
            let orderId =orderRequest.setRechargeOrderId(collect.userId);
            console.log('充值订单:', orderId);
            collect.orderInfo.orderId = orderId;
            //点击就录入充值信息
            let data = [{
                'userid':collect.orderInfo.userId,
                'orderid':collect.orderInfo.orderId,
                'paytype':collect.payMethod,
                'amount':collect.orderInfo.amount
            }];
            let params = "rechargeinfo=" + JSON.stringify(data);
            requestHandler.simpleRequest(constant.action.balancetransaction_insert, params,function (response) {
                console.log("预备充值信息",response);
                if(response.data[0].result==1){
                    if(collect.payMethod==1){
                        let params={
                            'out_trade_no': collect.orderInfo.orderId,
                            'subject': 'rechargeBalance',
                            'total_amount': collect.orderInfo.amount *100
                        };
                        console.log('params',params);

                        //判断设备是pc端还是移动端
                        if(collect.isMobile){

                        }else{
                            //PC端获取微信支付二维码接口constant.action.qrpay_wechat
                            requestHandler.simpleRequest(constant.action.qrpay_wechat,params,
                                function(respone){
                                    console.log( '微信调用成功：' , respone);
                                    common.loading.hide();
                                    $scope.orderInfo=collect.orderInfo;
                                    $scope.rechargeMomey=collect.orderInfo.amount;
                                    $scope.payMethod=collect.payMethod;
                                    $scope.qrcode=respone.data.qrcode;
                                    collect.qrpayModal=ModalWindow.open({
                                        'templateUrl':'app/views/modals/qrpayModal.html',
                                        'controller':'QrpayModalController',
                                        'width':320,
                                        'height':360,
                                        'scope':$scope,
                                        'windowClass':"qrpay_window"
                                    });
                                },
                                function(respone){
                                    console.log('微信调用二维码不成功' , respone);
                                    common.loading.hide();
                                }
                            );
                        }


                    }else if(collect.payMethod==0){

                        let params={
                            'out_trade_no': collect.orderInfo.orderId,
                            'subject': 'rechargeBalance',
                            'total_amount': collect.orderInfo.amount
                        };
                        console.log('params',params);

                        if(collect.isMobile){

                        }else{
                            //获取支付宝支付二维码接口constant.action.qrpay_ali
                            requestHandler.simpleRequest(constant.action.qrpay_ali,params,
                                function(respone){
                                    // console.log(respone);
                                    // return respone.data;
                                    console.log('支付宝二维码信息:' ,respone.data);
                                    common.loading.hide();
                                    $scope.orderInfo=collect.orderInfo;
                                    $scope.rechargeMomey=collect.orderInfo.amount;
                                    $scope.payMethod=collect.payMethod;
                                    $scope.qrcode=respone.data.qrcode;
                                    collect.qrpayModal=ModalWindow.open({
                                        'templateUrl':'app/views/modals/qrpayModal.html',
                                        'controller':'QrpayModalController',
                                        'width':320,
                                        'height':360,
                                        'scope':$scope,
                                        'windowClass':"qrpay_window"
                                    });

                                },
                                function(respone) {
                                    console.log('支付宝调用二维码不成功',respone);
                                    common.loading.hide();
                                }
                            );
                        }

                    }
                }
            });


        }

        //检查支付结果   手机端用的
        function checkPayResult(){
            var rechargeInfo =JSON.parse(sessionStorage.getItem("rechargeInfo")) ;
            if (rechargeInfo){
                /*
                * log start
                * */
                let _logdata = [{
                    "querytype":0,
                    "userid": rechargeInfo.userId,
                    "logcontent":'充值入库：'+JSON.stringify(rechargeInfo)

                }];
                let paramslog='debuglog='+JSON.stringify(_logdata);
                requestHandler.simpleRequest(constant.action.debuglog, paramslog,function (data) {
                    console.log("debug返回：",data);
                });
                /*
                * log end
                * */
                orderRequest.checkPayResult(rechargeInfo.paytype,rechargeInfo.orderId)
                    .then(function (resData){
                            console.log('手机端检测充值信息：',resData)
                            if(rechargeInfo.paytype==0){
                                collect.hasPaid=resData.trade_status=="TRADE_SUCCESS";
                            }else if(rechargeInfo.paytype==1){
                                collect.hasPaid=resData.trade_state=="SUCCESS";
                            }
                            //alert('手机检测timer');
                            if(collect.hasPaid){
                                console.log('移动端账户充值已经支付');
                                common.loading.hide();
                                //设置充值订单信息：用户账号， 充值金额，充值平台，充值单号，交易类型
                                console.log(collect.orderInfo);
                                orderRequest.setRechargeInfo(rechargeInfo.userId,rechargeInfo.amount,rechargeInfo.paytype,rechargeInfo.orderId,rechargeInfo.payAction).then(function (data) {
                                    if(data[0].result == 1){
                                        common.alert("充值成功");
                                        sessionStorage.removeItem('rechargeInfo');
                                        $timeout.cancel(collect.timer);     //在这里取消循环
                                        $state.go('main.user');
                                    }else{
                                        collect.timer=$timeout(collect.checkPayResult,collect.checkInterval);
                                    }
                                });
                            }else{
                                // $timeout.cancel(collect.timer);
                                collect.timer=$timeout(collect.checkPayResult,collect.checkInterval);
                            }
                        },
                        function (resData){
                            //alert('手机访问出错');
                            collect.timer=$timeout(collect.checkPayResult,collect.checkInterval);
                        }
                    );
            }else{
                collect.timer=$timeout(collect.checkPayResult,collect.checkInterval);
            }

        }

        function chooseMoneyBOC($bocdiscounttype)
        {
            if ($bocdiscounttype == 6)
            {
                collect.orderInfo.amount = collect.payamount;
            }
            else if ($bocdiscounttype == 7)
            {
                collect.orderInfo.amount = collect.bocpayamount_1;
            }
            else if ($bocdiscounttype == 8)
            {
                collect.orderInfo.amount = collect.bocpayamount_0;
            }

            vm.collect.payMethod=$bocdiscounttype;
        }

        function chooseMoneyOthers($paytype)
        {
            collect.orderInfo.amount = collect.payamount;
            vm.collect.payMethod=$paytype;
        }

        //点击选取充值金额
        function choseMoney(item,$index){

            vm.collect.isshowbtn7 = true;

            console.log('item值', item);
            console.log('下标值', $index);
            if (item.iswopay == "1")
            {
                $("#wopay_button").show();
                $("#alipay_button").hide();
                $("#wxpay_button").hide();

                $("#bocpay_button_6").hide();
                $("#bocpay_button_7").hide();
                $("#bocpay_button_8").hide();

                vm.collect.payMethod=5;
            }
            else
            {
                item.isbocpay = "0";

                if (item.isbocpay == "1")
                {
                    if (item.bocpay_index == "1")
                    {
                        $("#bocpay_button_6").show();
                        $("#bocpay_button_7").hide();
                        $("#bocpay_button_8").show();
                        vm.collect.payMethod=8;
                    }
                    else if (item.bocpay_index == "2")
                    {
                        $("#bocpay_button_6").show();
                        $("#bocpay_button_7").show();
                        $("#bocpay_button_8").hide();
                        vm.collect.payMethod=7;
                    }

                    $("#alipay_button").hide();
                    $("#wxpay_button").hide();
                    $("#wopay_button").hide();

                    //getOrderBOCPayInfo(10, $index);
                }
                else
                {
                    $("#alipay_button").show();
                    $("#wxpay_button").show();
                    $("#wopay_button").show();

                    $("#bocpay_button_6").show();
                    $("#bocpay_button_7").show();
                    $("#bocpay_button_8").show();

                    getOrderBOCPayInfo(item.money, 0);

                    //vm.collect.payMethod=0;
                }
            }
            $('.choseItem li').removeClass('active');
            $('.choseItem li').eq($index).addClass('active');
            collect.orderInfo.amount = item.money;
            collect.bocpayamount_order = item.money;
        }

        // 获取中行支付信息
        function getOrderBOCPayInfo($payamount, $keyindex) {
            let data={
                'userid':       collect.userId,
                'orderid':      "",
                'ordertype':    1,
                'amount':       $payamount
            };

            let paramsStr='orderinfo='+JSON.stringify(data);

            requestHandler.simpleRequest(constant.action.appPay_boc_amoundQuery_new, paramsStr,
                function successCallback(response) {
                    console.log(response);

                    collect.bocDiscount_0 = response.data.bocdiscount_0;
                    collect.bocDiscount_1 = response.data.bocdiscount_1;

                    /*
                    if (response.data.orderindex === 1)
                    {
                        collect.bocPayDescription = "当月首单1折优惠，5元封顶，订单金额1元以下免单";
                    }
                    else if (response.data.orderindex >= 2 && response.data.orderindex <= 4)
                    {
                        collect.bocPayDescription = "随机优惠，订单金额1元以下免单";
                    }
                    else
                    {
                        collect.bocPayDescription = "";
                    }
                    */
                    collect.bocPayDescription = "";

                    collect.payamount = response.data.payamount;
                    collect.bocpayamount_0 = response.data.payamount_0;
                    collect.bocpayamount_1 = response.data.payamount_1;

                    collect.bocpayamount_order = response.data.payamount;

                    /*
                    if (collect.bocDiscount_0 == 0)
                    {
                        if ($keyindex == 0)
                        {
                            collect.payMethod = 8;
                            collect.orderInfo.amount = collect.bocpayamount_0;
                        }
                        else
                        {
                            collect.payMethod = 7;
                            collect.orderInfo.amount = collect.bocpayamount_1;
                        }
                    }
                    else if (collect.bocDiscount_1 == 0)
                    {
                        if ($keyindex == 1)
                        {
                            collect.payMethod = 7;
                            collect.orderInfo.amount = collect.bocpayamount_1;
                        }
                        else
                        {
                            collect.payMethod = 6;
                            collect.orderInfo.amount = collect.payamount;
                        }
                    }
                    else*/
                    {
                        collect.payMethod = 6;
                        collect.orderInfo.amount = collect.payamount;
                    }
                },
                function errorCallback(response) {
                    console.log('获取boc支付信息失败');
                    console.log(response);
                }
            );
        }

        function getPayDiscount() {
            let _data = [{
                'operationtype':4,
                'customname':'余额支付',
                'querytype':1
            }];
            let paramsStr='discountinfo='+JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.paydiscountoperation, paramsStr,
                function(responce){
                    console.log("余额支付折扣信息：",responce.data[0]);
                    if(responce.data[0].result == 1){
                        collect.discountinfo = responce.data[0].discountinfo;
                    }
                },
                function(){

                }
            )
        }
        //获取个人详细信息
        function getUserInfo() {
            let params=[{
                'userid': collect.userId,
            }];
            let str='userinfo='+JSON.stringify(params);
            requestHandler.simpleRequest(constant.action.getUserInfoById,str).then(function (respone) {
                console.log(respone);   //这里有用户的个人信息，比如是否管理员
                collect.accountbalance = respone.data[0].users.rows[0].userbalance;  //余额
                collect.manager = respone.data[0].users.rows[0].groupname;
            });

        }
        //获取赠送比例
        function getRechargeGift(){
            let _data = {
                'operationtype' : 2
            };
            let paramsStr='rechargegift='+JSON.stringify([_data]);
            requestHandler.simpleRequest(constant.action.rechargegiftoperation, paramsStr,
                function(responce){

                    if(responce.data[0].result == 1){
                        collect.rechargegift = responce.data[0].rechargegift/100;
                        console.log('赠送比例信息', collect.rechargegift);
                        collect.orderInfo.rechargegift = responce.data[0].rechargegift/100;
                    }
                },
                function(){

                }
            )
        }
        function debuglog() {
            var rechargeInfo =JSON.parse(sessionStorage.getItem("rechargeInfo")) ;
            let _logdata = [{
                "querytype":0,
                "userid": rechargeInfo.userId,
                "logcontent":JSON.stringify(rechargeInfo),

            }];
            console.log("debug参数：",_logdata);
            let paramslog='debuglog='+JSON.stringify(_logdata);
            requestHandler.simpleRequest(constant.action.debuglog, paramslog,function (data) {
                console.log("debug返回：",data);
            })
        }

    }

}
